// todo: hoc dnd 교체 필요
import React from 'react';

const PortfolioView = () => {
  return <div></div>;
};

export default PortfolioView;

// import { arrayMove, getImageSet } from 'Util/DataUtils';
// import React, { useCallback, useState } from 'react';
// import { useIntl } from 'react-intl';
// import IntlMessages from 'Util/IntlMessages';
// import icSort from 'Assets/img/recruitment/ic_sort.png';
// import icSort2 from 'Assets/img/recruitment/ic_sort@2x.png';
// import icSort3 from 'Assets/img/recruitment/ic_sort@3x.png';
// import dash from 'Assets/img/recruitment/dash.png';
// import dash2 from 'Assets/img/recruitment/dash@2x.png';
// import dash3 from 'Assets/img/recruitment/dash@3x.png';
// import icDelete from 'Assets/img/recruitment/ic_list_delete.png';
// import icDelete2 from 'Assets/img/recruitment/ic_list_delete@2x.png';
// import icDelete3 from 'Assets/img/recruitment/ic_list_delete@3x.png';
// import { sortableContainer, sortableElement, SortableHandle } from 'react-sortable-hoc';
// import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
// import { TextField } from '@mui/material';
// import OneImagePopup from 'Components/Popup/OneImagePopup';
// import InputTitleView from '../InputTitleView';
// import ImageView from './ImageView';
// import { useSelector } from 'react-redux';
// import { getDotFormatDateFns } from 'Util/DateUtils';
// import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
// import { ko, vi } from 'date-fns/locale';

// const customFieldStyle = {
//   '& .MuiOutlinedInput-root': {
//     fieldset: {
//       border: '1px solid #DDD',
//       height: '44px',
//       width: '100%',
//     },
//     '&:hover fieldset': {
//       borderColor: '#DDD',
//     },
//     '&.Mui-focused fieldset': {
//       border: '1px solid #DDD',
//     },
//     '&.Mui-error fieldset': {
//       border: '1px solid #DDD',
//     },
//   },
// };
// const sortImgs = getImageSet([icSort, icSort2, icSort3]);
// const dashImgs = getImageSet([dash, dash2, dash3]);
// const deleteSet = getImageSet([icDelete, icDelete2, icDelete3]);

// const DragHandler = SortableHandle(() => (
//   <div className="portfolios-item-sort">
//     <img {...sortImgs} alt="sort" />
//   </div>
// ));

// const SortableItem = sortableElement(({ item, idx, onChangeInput, formatMessage, setImageModal, setNowImage, onClickDeleteItem, onChange, value, onSortEndImages, locale }) => (
//   <div key={`item_${idx}`} className="portfolios-item">
//     <div className="portfolios-item-contents-wrapper">
//       <div className="portfolios-item-contents">
//         <div className="portfolios-item-contents-title">
//           <IntlMessages id="recruitment.portfolios.images" />
//         </div>
//         <ImageView
//           item={item}
//           itemIndex={idx}
//           onChange={onChange}
//           setImageModal={setImageModal}
//           setNowImage={setNowImage}
//           value={value}
//           onSortEnd={({ oldIndex, newIndex }) =>
//             onSortEndImages({
//               images: item.images,
//               itemIndex: idx,
//               oldIndex,
//               newIndex,
//             })
//           }
//         />
//       </div>
//       <div className="portfolios-item-contents">
//         <div className="portfolios-item-contents-title">
//           <IntlMessages id="recruitment.portfolios.fieldName" />
//         </div>
//         <div className="portfolios-text-input">
//           <input
//             type="text"
//             name="fieldName"
//             placeholder={formatMessage({ id: 'recruitment.portfolios.fieldName.placeholder' })}
//             value={item.fieldName}
//             onChange={({ target }) => onChangeInput({ index: idx, name: target.name, value: target.value })}
//           />
//         </div>
//       </div>
//       <div className="portfolios-item-contents">
//         <div className="portfolios-item-contents-title">
//           <IntlMessages id="recruitment.portfolios.client" />
//         </div>
//         <div className="portfolios-text-input">
//           <input
//             type="text"
//             name="client"
//             placeholder={formatMessage({ id: 'recruitment.portfolios.client.placeholder' })}
//             value={item.client}
//             onChange={({ target }) => onChangeInput({ index: idx, name: target.name, value: target.value })}
//           />
//         </div>
//       </div>
//       <div className="portfolios-item-contents">
//         <div className="portfolios-item-contents-title">
//           <IntlMessages id="recruitment.companyHistories.date" />
//         </div>
//         <div className="portfolios-date-input-wrapper">
//           <div className="portfolios-date-input">
//           <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={locale === 'vi' ? vi : ko}>
//               <DatePicker
//                 inputFormat={getDotFormatDateFns(locale)}
//                 className="datePicker"
//                 id="date"
//                 value={item.dateStart}
//                 onChange={e => onChangeInput({ index: idx, name: 'dateStart', value: e })}
//                 renderInput={params => (
//                   <TextField
//                     {...params}
//                     sx={customFieldStyle}
//                     placeholder={formatMessage({ id: 'recruitment.portfolios.dateStart.placeholder' })}
//                     inputProps={{
//                       ...params.inputProps,
//                       placeholder: formatMessage({ id: 'recruitment.portfolios.dateStart.placeholder' }),
//                     }}
//                   />
//                 )}
//               />
//             </LocalizationProvider>
//           </div>
//           <div className="portfolios-date-image">
//             <img {...dashImgs} alt="dash" />
//           </div>
//           <div className="portfolios-date-input">
//           <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={locale === 'vi' ? vi : ko}>
//               <DatePicker
//                 inputFormat={getDotFormatDateFns(locale)}
//                 className="datePicker"
//                 id="date"
//                 value={item.dateEnd}
//                 onChange={e => onChangeInput({ index: idx, name: 'dateEnd', value: e })}
//                 renderInput={params => (
//                   <TextField
//                     {...params}
//                     sx={customFieldStyle}
//                     placeholder={formatMessage({ id: 'recruitment.portfolios.dateEnd.placeholder' })}
//                     inputProps={{
//                       ...params.inputProps,
//                       placeholder: formatMessage({ id: 'recruitment.portfolios.dateEnd.placeholder' }),
//                     }}
//                   />
//                 )}
//               />
//             </LocalizationProvider>
//           </div>
//         </div>
//       </div>
//     </div>
//     <DragHandler />
//     <div className="portfolios-item-delete" onClick={() => onClickDeleteItem(idx)}>
//       <img {...deleteSet} alt="delete" />
//     </div>
//   </div>
// ));
// const SortableContainer = sortableContainer(({ children }) => <div className="portfolios-wrapper">{children}</div>);

// const PortfolioView = ({ value, onChange }) => {
//   const { formatMessage } = useIntl();
//   const { locale } = useSelector(state => state.settings.locale);
//   const [imageModal, setImageModal] = useState(false);
//   const [nowImage, setNowImage] = useState('');

//   const onClickAddPortfolio = () => {
//     onChange({
//       name: 'portfolios',
//       value: [
//         {
//           fieldName: '',
//           client: '',
//           images: [],
//           dateStart: null,
//           dateEnd: null,
//         },
//         ...value,
//       ],
//     });
//   };

//   const onClickDeleteItem = index => {
//     onChange({
//       name: 'portfolios',
//       value: value.filter((_, i) => i !== index),
//     });
//   };

//   const onChangeInput = ({ index, name, value: nowValue }) => {
//     onChange({
//       name: 'portfolios',
//       value: value.map((x, i) => {
//         if (index !== i) return x;
//         return {
//           ...x,
//           [name]: nowValue,
//         };
//       }),
//     });
//   };

//   const onSortEnd = useCallback(
//     ({ oldIndex, newIndex }) => {
//       const items = arrayMove(value, oldIndex, newIndex);
//       onChange({
//         name: 'portfolios',
//         value: items,
//       });
//     },
//     [value]
//   );

//   const onSortEndImages = useCallback(
//     ({ images, itemIndex, oldIndex, newIndex }) => {
//       const items = arrayMove(images, oldIndex, newIndex);
//       onChange({
//         name: 'portfolios',
//         value: value.map((x, i) => {
//           if (i !== itemIndex) return x;
//           return {
//             ...x,
//             images: items,
//           };
//         }),
//       });
//     },
//     [value]
//   );

//   return (
//     <>
//       <div className="recruitment-portfolios-view">
//         <InputTitleView title={formatMessage({ id: 'recruitment.portfolios' })} required={false} subTitle="" />
//         <div className="recruitment-portfolios-wrapper">
//           <div className="recruitment-portfolios-button" onClick={onClickAddPortfolio}>
//             <IntlMessages id="recruitment.portfolios.button" />
//           </div>
//           {value.length > 0 && (
//             <div className="recruitment-list-guide">
//               <IntlMessages id="recruitment.list.guide" />
//             </div>
//           )}
//           <SortableContainer onSortEnd={onSortEnd} axis="y" distance={1} helperClass="portfolios-drag-item" useDragHandle>
//             {value.map((item, idx) => (
//               <SortableItem
//                 key={idx}
//                 index={idx}
//                 idx={idx}
//                 item={item}
//                 onChangeInput={onChangeInput}
//                 formatMessage={formatMessage}
//                 setImageModal={setImageModal}
//                 setNowImage={setNowImage}
//                 onClickDeleteItem={onClickDeleteItem}
//                 onChange={onChange}
//                 value={value}
//                 onSortEndImages={onSortEndImages}
//                 locale={locale}
//               />
//             ))}
//           </SortableContainer>
//         </div>
//       </div>
//       <OneImagePopup image={nowImage} modal={imageModal} onClose={() => setImageModal(false)} />
//     </>
//   );
// };

// export default PortfolioView;
